import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=3cc1aca9&scoped=true&"
import script from "./HelpModal.vue?vue&type=script&lang=ts&"
export * from "./HelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./HelpModal.vue?vue&type=style&index=0&id=3cc1aca9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc1aca9",
  null
  
)

export default component.exports